import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import { FaChevronDown } from 'react-icons/fa';

const SelectorWrapper = styled.div`
  position: relative;
  width: 200px;
  z-index: 20;
`;

const SelectedValue = styled.button`
  width: 100%;
  background: var(--glass-bg);
  color: var(--primary-color);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  padding: 12px 15px;
  font-size: 1rem;
  outline: none;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: border-color 0.3s ease;

  &:hover, &:focus {
    border-color: var(--gradient-pink);
  }
`;

const OptionsList = styled(motion.ul)`
  position: absolute;
  top: 110%;
  left: 0;
  width: 100%;
  list-style: none;
  background: #1c102c;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  padding: 5px;
  max-height: 200px;
  overflow-y: auto;
`;

const OptionItem = styled.li`
  padding: 10px 15px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: var(--gradient-pink);
  }
`;

const SeasonSelector = ({ seasons, selectedSeason, onSeasonChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [wrapperRef]);
  
  const handleSelect = (seasonNumber) => {
    onSeasonChange(seasonNumber);
    setIsOpen(false);
  };

  const listVariants = {
    hidden: { opacity: 0, y: -10 },
    visible: { opacity: 1, y: 0 }
  }

  return (
    <SelectorWrapper ref={wrapperRef}>
      <SelectedValue onClick={() => setIsOpen(!isOpen)}>
        Sezon {selectedSeason}
        <motion.div animate={{ rotate: isOpen ? 180 : 0 }}>
          <FaChevronDown />
        </motion.div>
      </SelectedValue>
      <AnimatePresence>
        {isOpen && (
          <OptionsList variants={listVariants} initial="hidden" animate="visible" exit="hidden">
            {seasons.map(season =>
              season.season_number > 0 && (
                <OptionItem key={season.id} onClick={() => handleSelect(season.season_number)}>
                  Sezon {season.season_number}
                </OptionItem>
              )
            )}
          </OptionsList>
        )}
      </AnimatePresence>
    </SelectorWrapper>
  );
};

export default SeasonSelector;